import React from "react";
import ReactDOM from "react-dom";
import AppBarDesktop from "./AppBarDesktop";

class AppBarPortal extends React.Component {
  constructor(props) {
    super(props);

    this.rootSelector = document.getElementById("desktop-header");
    this.container = document.createElement("div");
  }

  componentDidMount() {
    this.rootSelector.appendChild(this.container);
  }

  componentWillUnmount() {
    this.rootSelector.removeChild(this.container);
  }

  render() {
    const component = this.props.isAuthenticated ? <AppBarDesktop /> : <AppBarDesktop />;
    return ReactDOM.createPortal(component, this.container);
  }
}

export default AppBarPortal;


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppBarPortal.js